// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { inspect } from "util";
export const custom = inspect.custom;
//# sourceMappingURL=inspect.js.map